// WeightTrendCard (plan todo 23) — getWeightTrend tool result: trend weight
// versus raw weigh-in plus the weekly drift, with an Open-in-Progress action.

import { TrendingDown } from "lucide-react";
import type { WeightTrendData } from "./card-data";
import { ChatCardShell, MacroChip, OpenInButton } from "./card-ui";

export interface WeightTrendCardProps {
  readonly data: WeightTrendData;
  readonly onSwitchScreen?: (screen: string) => void;
}

function formatKg(value: number): string {
  return `${value.toFixed(1)} kg`;
}

function formatDrift(driftKgPerWeek: number): string {
  const sign = driftKgPerWeek > 0 ? "+" : driftKgPerWeek < 0 ? "−" : "";
  return `${sign}${Math.abs(driftKgPerWeek).toFixed(2)} kg/week`;
}

export function WeightTrendCard({ data, onSwitchScreen }: WeightTrendCardProps) {
  return (
    <ChatCardShell
      icon={TrendingDown}
      title="Weight trend"
      testId="chat-card-weight-trend"
    >
      <div className="flex flex-col gap-1.5 text-sm">
        {data.trendKg !== undefined && (
          <div className="flex items-baseline justify-between" data-testid="weight-trend-trend">
            <span className="text-text-muted">Trend weight</span>
            <span className="font-semibold text-text">{formatKg(data.trendKg)}</span>
          </div>
        )}
        {data.rawKg !== undefined && (
          <div className="flex items-baseline justify-between" data-testid="weight-trend-raw">
            <span className="text-text-muted">Latest weigh-in</span>
            <span className="font-medium text-text">{formatKg(data.rawKg)}</span>
          </div>
        )}
        {data.driftKgPerWeek !== undefined && (
          <div className="flex items-baseline justify-between" data-testid="weight-trend-drift">
            <span className="text-text-muted">Weekly drift</span>
            <span className="font-semibold text-accent">{formatDrift(data.driftKgPerWeek)}</span>
          </div>
        )}
        {data.goalKg !== undefined && (
          <div className="flex items-baseline justify-between" data-testid="weight-trend-goal">
            <span className="text-text-muted">Goal</span>
            <span className="font-medium text-text">{formatKg(data.goalKg)}</span>
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {data.trendConfidence !== undefined && (
          <MacroChip label="Trend confidence" value={data.trendConfidence} />
        )}
      </div>
      <OpenInButton
        label="Open in Progress"
        screen="progress"
        testId="weight-trend-open-btn"
        onSwitchScreen={onSwitchScreen}
      />
    </ChatCardShell>
  );
}
